import { createSelector } from 'reselect';
import { PREFERENCES_V2_REDUCER_KEY } from './preferencesV2Reducer';

export const getResourceStore = (state) => state[PREFERENCES_V2_REDUCER_KEY];
export const getLoadPending = (state) => getResourceStore(state).loadPending;
export const getIsLoading = (state) => getResourceStore(state).isLoading;
export const getError = (state) => getResourceStore(state).error;
export const getLastSyncDate = (state) => getResourceStore(state).lastSyncDate;
// note - this gives a key value pairing based on name
export const getPreferencesV2 = (state) => getResourceStore(state).resourcesById;

export const getPreferenceObj = createSelector(
  getPreferencesV2,
  (state, name) => name,
  (preferencesByName, name) => preferencesByName.get(name),
);

export const getPreferenceValue = createSelector(
  (state, name) => getPreferenceObj(state, name),
  (state, name, defaultValue) => defaultValue,
  (preferenceObj, defaultValue) => {
    if (!preferenceObj) {
      return defaultValue;
    }
    return preferenceObj?.value;
  },
);
